/* ----------------------------------- */ 
// Domain import pattern. Please       //
// follow below usage for all reducers // 
/* ----------------------------------- */

import initialState             from './initial';
import * as Types               from '../actions/types';
import { createReducer }        from 'redux-immutablejs';
import { fromJS }               from 'immutable';

const initial = fromJS( initialState.products );

const products =  createReducer(initial, {
    [Types.UPDATE_PRODUCT_DOMAIN_DATA]: (state, action) => 
        state.merge({
            list : action.payload.data.products,
            filters: state.get('filters').merge({
                category : action.payload.data.categories[0]
            })
        }),
    [Types.CHANGE_SORTING]: (state, action) => 
        state.merge({
            sort : action.payload
        }),
    [Types.CHANGE_PAGE]: (state, action) => 
        state.merge({
            page : action.payload
        }),
    [Types.CHANGE_CATEGORY_FILTER]: (state, action) => 
        state.merge({
            page: 1,
            filters: state.get('filters').merge({
                category : action.payload
            })
        }),
    [Types.ADD_FILTER]: (state, action) =>
        state.merge({
            page: 1,
            filters: state.get('filters').merge({
                [action.payload.node]: action.payload.value
                                        ?   [ ...state.getIn([ 'filters', action.payload.node ]), action.payload.value ]
                                        :   []
            })
        }),
    [Types.REMOVE_FILTER]: (state, action) =>
        state.merge({
            page: 1,
            filters: state.get('filters').merge({
                [action.payload.node]: [ ...state.getIn([ 'filters', action.payload.node ]).filter(f => f !== action.payload.value) ]
            })
        }),
    [Types.ADD_PRODUCT_TO_CART]: (state, action) =>
        state.merge({
            cart: {
                products: [ ...state.getIn([ 'cart', 'products' ]), action.payload ],
                totalPrice: state.getIn([ 'cart', 'totalPrice' ]) + action.payload.price,
            }
        }),
    [Types.CHANGE_PRODUCT_IN_CART]: (state, action) => {
        const currentCart   = state.getIn([ 'cart', 'products' ]).toJS();
        let product         = currentCart.find(p => p.slug === action.payload.product.slug);
        product.count       = action.payload.product.count;
        return state.merge({
            cart: {
                products: currentCart,
                totalPrice: state.getIn([ 'cart', 'totalPrice' ]) + ( action.payload.product.price * action.payload.diff )
            }
        })
    },
    [Types.REMOVE_PRODUCT_FROM_CART]: (state, action) => {
        const currentCart   = state.getIn([ 'cart', 'products' ]).toJS();
        const newCart       = [ ...currentCart.filter(p => p.slug !== action.payload.slug) ];
        return state.merge({
            cart: {
                products: newCart,
                totalPrice: newCart.length ? state.getIn([ 'cart', 'totalPrice' ]) - action.payload.price : 0
            }
        })
    },
});

export default products;